import { ChangeReferenceDto } from 'src/app/data-transfer/entities/change-reference-dto';
import { ImportCandidateDto } from 'src/app/data-transfer/entities/import-candidate-dto';
import { PackagingPart } from 'src/app/model/packaging-part-enum';

// could potentially be part of a more global mapping strategy with a centralized interface declaration and classes for mappers

export interface ImportTableRowFields {
  itemId: number;
  displayId: number;
  version?: number | null;
  brandName?: string | null;
  productName?: string | null;
  articleName?: string | null;
  articleNumber?: string | null;
  packagingTypeName?: string | null;
  packagingComponentCategoryName?: string | null;
  packagingComponentSubtypeName?: string | null;
}

export type ImportRow = ImportCandidateDto & ImportTableRowFields;
export type ChangeRow = ChangeReferenceDto & ImportTableRowFields & { organizationId: number; lastModificationTimestamp: string };

type ImportRowSource = Partial<Omit<ImportTableRowFields, 'itemId' | 'displayId'>>;

const IMPORT_DATA_KEY: Record<PackagingPart, string> = {
  [PackagingPart.System]: 'packagingSystem',
  [PackagingPart.Unit]: 'packagingUnit',
  [PackagingPart.Component]: 'packagingComponent',
  [PackagingPart.Material]: 'multiMaterial',
};

export function mapImportRow(entry: ImportCandidateDto, packagingPart: PackagingPart): ImportRow {
  const source = (entry as unknown as Record<string, ImportRowSource>)[IMPORT_DATA_KEY[packagingPart]];
  return {
    ...entry,
    itemId: entry.id,
    displayId: entry.id,
    version: source.version,
    brandName: source.brandName,
    productName: source.productName,
    articleName: source.articleName,
    articleNumber: source.articleNumber,
    packagingTypeName: source.packagingTypeName,
    packagingComponentCategoryName: source.packagingComponentCategoryName,
    packagingComponentSubtypeName: source.packagingComponentSubtypeName,
  };
}

export function mapChangeRow(entry: ChangeReferenceDto): ChangeRow {
  const { updated } = entry;
  return {
    ...entry,
    itemId: entry.id,
    displayId: entry.updatedId,
    version: updated.version,
    brandName: updated.brandName,
    productName: updated.productName,
    articleName: updated.articleName,
    articleNumber: updated.articleNumber,
    packagingTypeName: updated.packagingTypeName,
    packagingComponentCategoryName: updated.packagingComponentCategoryName,
    packagingComponentSubtypeName: updated.packagingComponentSubtypeName,
    organizationId: updated.organizationId,
    lastModificationTimestamp: updated.lastModificationTimestamp,
  };
}
